<template>
  <figure>
    <a class="download-link" :class="clase" :href="publicPath+file" :type="type" :download="downloadname">
      <img v-if="cover" class="download-cover" :src="publicPath+cover" alt="" style="max-width: 100%">
      <span class="download-icon"> 
        <arrow-down :size="24" />
        {{ name }}<span class="a11y-solo-lectura">.</span>
      </span>
    </a>
    <figcaption class="a11y-solo-lectura">
      Archivo descargable en formato: {{ format }}, peso: {{weight}}.
    </figcaption>
  </figure>
</template>

<script>
import ArrowDown from 'vue-material-design-icons/ArrowDownCircle.vue'

export default {
  name: 'DownloadFile',
  components: {
    ArrowDown
  },
  props: {
    file: String,
    type: String,
    format: String,
    name: String,
    downloadname: String,
    weight: String,
    cover: String,
    clase: String
  },
  methods: {},
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  computed: {},
}
</script>

<style scoped lang="scss">
.download-link {
  display: inline-block;
  .download-cover {
    display: block;
    border-radius: $border-radius;
    border: 1px solid rgba(0,0,0,.1);
    box-shadow: 0 4px 10px rgba(0,0,0,.1);
    overflow: hidden;
    transition: box-shadow .27s ease-in-out;
    margin-bottom: $space*.5;
  }
  .download-icon {
    margin-bottom: $space * .5;
    display: flex;
    color: $accion;
    transition: color .27s ease-in-out;
    .material-design-icon {
      margin-right: $space * .15;
      transition: margin-top .27s ease-in-out;
    }
  }
  &:hover, &:focus {
    background: none;
    .download-cover {
      box-shadow: 0 4px 10px rgba(0,0,0,.3);
    }
    .download-icon {
      color: $accion;
      .material-design-icon {
        margin-top: $font-size-base*.5;
      }
    }
  }
}
</style>
